import { ProductTagBase } from '../ProductTagBase';
import klass from '../style/ProductTag.module.scss';
import { type Html } from 'rune-ts';
import { UserFillIcon } from '../../../atoms/Icon';

export class WatcherCountTag extends ProductTagBase<number> {
  protected makeLabel(): string | undefined {
    return ET(`product::n_viewing::compact`, {
      n: this.data.value.toLocaleString(),
      lng: this.data.lang,
    });
  }

  protected styles(): string {
    return klass.watcher_count;
  }

  isTimerNeeded(): boolean {
    return false;
  }

  override getIcon(): Html {
    return UserFillIcon;
  }
}
